import React from "react";
import { FaNewspaper } from "react-icons/fa";

const NewspaperLogo = () => <FaNewspaper color="black" size={"40px"} />;

export default NewspaperLogo;
